import { fromLatLng, setKey, setLanguage } from 'react-geocode';
import { environment } from '../environments/environment';
import { Point } from '../types/geoModels';

setKey(environment.googleMapsAPIKey ?? '');
setLanguage('es');

export const getAddressFromPoint = async (point: Point) => {
  try {
    const response = await fromLatLng(point.lat, point.lng);
    const address: string = response.results[0].formatted_address;

    return address;
  } catch (_) {}
};
